import "reflect-metadata";
import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.scss';
import {App} from './App';
import {getContainer, wireApplication} from "./ioc/IOCSetup";
import {getTargetLanguagePath} from "./i18n";
import {Settings} from "./http/protocol";
import {HttpService} from "./http/HttpService";
import {DISABLE_TOASTS, SettingsService, SettingsWithSite} from "./settings/SettingsService";
import ContentfulClientService from "./contenful/ContentfulClientService";
import {FacebookApi} from "./FacebookApi";
import {Locale} from "./contenful/types";
import {Locale as ContentfulLocale, LocaleCollection} from "contentful";
import Cookies from "js-cookie";
import FingerprintJS, {Agent} from "@fingerprintjs/fingerprintjs";
import {Agent as AgentPro}  from '@fingerprintjs/fingerprintjs-pro';
import {UserService} from "./user/UserService";
import {ACTIVE_LOCALE_COOKIE, LocaleStatus} from "./bootstrap-utils";
import { searchParams } from "./http/Types";
import StrapiClient from "./contenful/StrapiClient";
import {mapStrapiAttributes, mapStrapiContent} from "./contenful/ContentfulActions";


const AFFILIATE_TRACKER_CLICKED  = "affiliateTrackerClicked";







export function startApplication(config : any,
                                 settings : SettingsWithSite,
                                 settingsService : SettingsService,
                                 httpService : HttpService,
                                 domain : string,
                                 contentfulService : ContentfulClientService,
                                 strapiClient : StrapiClient,
                                 promises : Promise<[String,LocaleStatus,String]>){
    start(config,settings, settingsService, httpService, domain, contentfulService, strapiClient, promises as any).then(r => console.log("Done!"));
}
async function start(
        config : any,
        settings : SettingsWithSite,
        settingsService : SettingsService,
        httpService : HttpService,
        domain : string,
        contentfulClientService : ContentfulClientService,
        strapiClient : StrapiClient,
        promises : Promise<[String,LocaleStatus]>) {

            

    settingsService.setSettingsData(settings);

    let activeLocale;
    let targetLocale;
    let localeFromPath;
    try {
        let results = await promises;

        activeLocale = results[1].activeLocale;
        targetLocale = activeLocale?.code ?? "en";
        localeFromPath = results[1].localeFromPath;

    } catch (e) {
        console.log("Unable to load required resources", e);
        return;
    }



    //Load Fingerprint
    let fingerprintEnabled = settings.fingerprintEnabled;
    let fingerprintPublicKey = settings.fingerprintPublicKey;
    let fingerprintDomain = settings.fingerprintDomain;
    try {
        if(fingerprintEnabled && fingerprintDomain && fingerprintPublicKey) {
        const FingerprintJSPro = require('@fingerprintjs/fingerprintjs-pro');
         // Initialize the agent on page load.
         FingerprintJSPro.load({
            apiKey: fingerprintPublicKey,
            endpoint: [
                `https://${fingerprintDomain}`,
                FingerprintJSPro.defaultEndpoint
            ],
            scriptUrlPattern: [
              `https://${fingerprintDomain}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`,
              FingerprintJSPro.defaultScriptUrlPattern
            ],
            region: "eu"
          }).then((agent: AgentPro) => {
            if(agent) {
            window.fingerprintPro = agent;
            }
        });
        } 
            FingerprintJS.load().then((agent:Agent) => {
                if(agent) {
                    window.fingerprint = agent;
                }
            })
        
    
    } catch (e) {
        console.log("Failed to initialize fp", e);
    }

    let fb;
    if(settings && settings.facebookAppId && settings.facebookAppId != "") {
        try {
            fb = new FacebookApi(settings.facebookAppId);
            await fb.init((status : any)=>{
                console.log("Facebook status callback ", status);
            });
        } catch (e) {
            fb = new FacebookApi(undefined);
            console.log("facebook not supported")
        }
    } else {
        fb = new FacebookApi(undefined);
    }



    //Set favicon from contentful.
    try {
        let strapiEnabled = strapiClient.isEnabled();
        if(strapiEnabled) {
           strapiClient.fetchContent("global", activeLocale.code).then((r : any) => {
               if(r.data?.attributes) {
                    let d = mapStrapiAttributes(r.data.attributes);
                    let url = "";
                   if(d.favicon) {
                       url = d.favicon?.fields?.file?.url;
                   }
                   let link = document.createElement('link');
                   link.type = 'image/x-icon';
                   link.rel = 'shortcut icon';
                   link.href = url;
                   document.getElementsByTagName('head')[0].appendChild(link);

               }
            });
        } else {
            contentfulClientService.getEntries('global', activeLocale.code).then((data:any) => {
                if(data != undefined) {
                    let url = "";
                    if(data.items[0] && data.items[0].fields.favicon) {
                        url = data.items[0].fields?.favicon?.fields?.file?.url;
                    }
                    let link = document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = url;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
            });
        }

    } catch (e) {
        console.log(e);
    }

    // Used in development to detect IP. To be uncommented if any problems accours  

    // let domain = ((document as any).domain.match(/[^\.]*\.[^.]*\.[^.]*$/) != null ? (document as any).domain.match(/[^\.]*\.[^.]*\.[^.]*$/)[0] : "") ;
    // if(domain.length == 0) {
    //     domain = (document as any).domain;
    // } 

    // document.domain is Deprecated and its replaced with location.hostname. 


    //cookie monster
    const domainValue = "domain=" + domain + ";";

    setTrackingCookies(domainValue, httpService).then(()=>{
        clearURLSearchParams();
    })
    console.log("localeFromPath", localeFromPath, "targetLocale", targetLocale)
    if(!localeFromPath || localeFromPath != targetLocale) {
        if(localeFromPath) {
            let path = getTargetLanguagePath(localeFromPath, targetLocale);
            window.history.replaceState(null,"", path);
        } else {
            let path = `/${targetLocale}${document.location.pathname}${document.location.search}`;
            window.history.replaceState(null, "", path)
        }
        localeFromPath = targetLocale;
    }
    settingsService.setActiveLocale(activeLocale);

    Cookies.set(ACTIVE_LOCALE_COOKIE, activeLocale.code,  {expires : 365, domain: domain, path : "/"});

    //Set title for page
    const title = settings.title ? settings.title : "";
    document.title = settingsService.appModeTitle ? "Loading..." : title
    
    let iosTitle = document.createElement('meta');
    iosTitle.name="apple-mobile-web-app-title";
    iosTitle.content = title;


    wireApplication(config, settings.contenfulSpaceId ?? "", settings.contentfulAccessToken ?? "", fb, settings.strapiApiUrl);

    try {
        let urlParams = new URLSearchParams(window.location.search);

        if(urlParams.has(DISABLE_TOASTS)) {
            if(urlParams.get(DISABLE_TOASTS) == "true") {
                settingsService.setDisableToasts();
            } else {
                settingsService.removeDisableToasts();
            }
        }
    } catch (e) {
        console.log("unable to set disable toasts",e)
    }

    document.documentElement.lang = activeLocale.code;
    let loader = document.getElementById("jsLoader");
    if(loader) {
        loader.style.display = "none";
    }
/*     if(settings && settings?.menu && settings?.menu?.settings && settings?.menu?.settings?.iconPack){
        addIconOverride(settings?.menu?.settings?.iconPack);
    } */
    const root = createRoot(document.getElementById('root') as HTMLElement)

    root.render(<App locale={localeFromPath}  />);

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
   // serviceWorker.register();
}

async function setTrackingCookies(domain : string, httpService:HttpService) {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('ref')) {
        let trackerValue = urlParams.get('ref');
        document.cookie = `refcode=${trackerValue};max-age=345600;${domain};samesite=lax;path=/`;

        try {
            if (Cookies.get(AFFILIATE_TRACKER_CLICKED) == undefined && trackerValue != null) {

                let userService = new UserService(httpService);

                userService.affiliateTrackerClicked(trackerValue).then(r => {
                    Cookies.set(AFFILIATE_TRACKER_CLICKED, "true")
                    console.log("tracker counted");
                });
            }
        } catch (ex) {
            console.log("error counting tracker " + ex)
        }
    }
    if (urlParams.has('btag')) {
        let btag = urlParams.get('btag');
        document.cookie = `btag=${btag};max-age=345600;${domain};samesite=lax;path=/`;
    }
    if (urlParams.has('ca')) {
        let campaignValue = urlParams.get('ca');
        document.cookie = `campaign=${campaignValue};max-age=345600;${domain};samesite=lax;path=/`;
    }
    if (urlParams.has('ch')) {
        let channelValue = urlParams.get('ch');
        document.cookie = `mchannel=${channelValue};max-age=345600;${domain};samesite=lax;path=/`;
    }
    if (urlParams.has('src')) {
        let sourceValue = urlParams.get('src');
        document.cookie = `src=${sourceValue};max-age=345600;${domain};samesite=lax;path=/`;
    }
    if (urlParams.has('cur')) {
        let cur = urlParams.get('cur');
        document.cookie = `cur=${cur};max-age=345600;${domain};samesite=lax;path=/`;
    }
    if (urlParams.has('click_id')) {
        let clickId = urlParams.get('click_id');
        document.cookie = `click_id=${clickId};max-age=345600;${domain};samesite=lax;path=/`;
    }
}

function path(params: string){
    return `${window.location.href.split('?')[0]}?${params}`
}

// Clear linked search params after saving them as cookies. 
function clearURLSearchParams(){
    let urlParams = new URLSearchParams(window.location.search);
    Object.entries(searchParams).forEach(([_, val]) => {
        if(urlParams.has(val)){
            if(urlParams.has('type')){
                urlParams.delete(val);
                return window.history.replaceState(null, '', path(urlParams.toString()));
            }
            if(urlParams.has('appMode')){
                urlParams.delete(val);
                return window.history.replaceState(null, '', path(urlParams.toString()));
            } 
            window.history.replaceState(null, '', window.location.pathname);
        }
    })
}


function addIconOverride(href: string) {
    return new Promise<string>((resolve, reject) => {
        let link    = document.createElement('link');
        link.type   = 'text/css';
        link.rel    = 'stylesheet';
        link.onload = () => {
            resolve(href);
        };
        link.onerror = () => { reject();};
        link.href   = href;
        let body = document.querySelector('head');
        body && body.appendChild(link);
    });
}